import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C3Text } from "../../../common/components/text/CustomText";
import CustomInput from "../../../common/components/input/CustomInput";
import { useState } from "react";
import CustomRadios from "../../../common/components/radio/CustomRadios";
import CustomSunEditor from "../../../common/components/suneditor/CustomSunEditor";
import Translate from "../../../common/translate/Translate";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import { Theme } from "../../../common/Theme";
import SettingsService from "../../../service/SettingsService";

const deviceTypeOptions = [
    { value: "Washer", label: Translate("common.washer") },
    { value: "Dryer", label: Translate("common.dryer") },
];

const modelTypeOptions = [
    { value: "Semi", label: Translate("setting.modelType.semi") },
    { value: "Professional", label: Translate("setting.modelType.professional") },
];

const GuideOptions = [
    { value: "ErrorCode", label: Translate("setting.faq.type.errorCode") },
    { value: "PCC", label: Translate("setting.faq.type.pcc") },
    { value: "UserGuide", label: Translate("setting.faq.type.userGuide") },
];

// PCC 선택 시 Code 입력에 사용할 드롭다운 항목 (선택값이 곧 code request 값)
const pccCodeOptions = [
    { value: "BUBBLE", label: "BUBBLE" },
    { value: "TUB_OVLD", label: "TUB_OVLD" },
    { value: "VALVE_CHANGE", label: "VALVE_CHANGE" },
];

const countryValues = [
    { label: Translate("country.select"), value: "select", color: Theme.color.rose500 },
    { label: Translate("country.korea"), value: "korea" },
    { label: Translate("country.chile"), value: "chile" },
    { label: Translate("country.usa"), value: "usa" },
    { label: "china", value: "china" },
    { label: "taiwan", value: "taiwan" },
    { label: "uk", value: "uk" },
    { label: "france", value: "france" },
];

function FAQSaveContent({ dto, onCancelClick, onSaveSuccess }) {
    const service = new SettingsService();

    const [selectedGuideType, setSelectedGuideType] = useState(dto?.deviceType || "lgGuide");
    const [title, setTitle] = useState(dto?.title || "");
    const [subTitle, setSubtitle] = useState(dto?.subtitle || "");
    const [selectedDeviceType, setSelectedDeviceType] = useState(dto?.deviceType || "Washer");
    const [selectedModelType, setSelectedModelType] = useState(dto?.modelType || "Semi");
    const [selectedGuideOption, setSelectedGuideOption] = useState(dto?.guideOption || "ErrorCode");
    const [code, setCode] = useState(dto?.code || "");
    const [selectedCountry, setSelectedCountry] = useState(dto?.country || "select");
    const [guideContent, setGuideContent] = useState(dto?.guideContent || "");

    return (
        <SizedBox height={"auto"} width={"100%"} maxWidth={"800px"} alignItem={"flex-start"} padding={"32px 0"}>
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"150px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{"Guide"}</C3Text>
                </SizedBox>
                <CustomRadios
                    options={[
                        { value: "lgGuide", label: "LG Guide" },
                        { value: "franchiseGuide", label: "Franchise Guide" },
                    ]}
                    selectedOption={selectedGuideType}
                    setSelectedOption={setSelectedGuideType}
                />
            </Row>
            <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"145px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("common.title")}</C3Text>
                </SizedBox>
                <CustomInput
                    type={"normal"}
                    placeholder={Translate("placeholder.title")}
                    inputValue={title}
                    setInputValue={setTitle}
                />
            </Row>
            <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"145px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("common.subtitle")}</C3Text>
                </SizedBox>
                <CustomInput
                    type={"normal"}
                    placeholder={Translate("placeholder.subtitle")}
                    inputValue={subTitle}
                    setInputValue={setSubtitle}
                />
            </Row>
            <Divider marginTop={"11px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"150px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("setting.deviceType")}</C3Text>
                </SizedBox>
                <CustomRadios
                    options={deviceTypeOptions}
                    selectedOption={selectedDeviceType}
                    setSelectedOption={setSelectedDeviceType}
                />
            </Row>
            <Divider marginTop={"23px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"150px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("setting.modelType")}</C3Text>
                </SizedBox>
                <CustomRadios
                    options={modelTypeOptions}
                    selectedOption={selectedModelType}
                    setSelectedOption={setSelectedModelType}
                />
            </Row>
            <Divider marginTop={"23px"} marginBottom={"23px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"150px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("setting.faq.type")}</C3Text>
                </SizedBox>
                <CustomRadios
                    options={GuideOptions}
                    selectedOption={selectedGuideOption}
                    setSelectedOption={(value) => {
                        setSelectedGuideOption(value);
                        // 모드 전환 시 이전 code 값이 남지 않도록 초기화
                        setCode("");
                    }}
                />
            </Row>
            <Divider marginTop={"23px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"145px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("common.code")}</C3Text>
                </SizedBox>
                {selectedGuideOption === "PCC" ? (
                    <CustomInput
                        type={"select"}
                        placeholder={Translate("placeholder.code")}
                        dropdownValues={pccCodeOptions}
                        inputValue={code}
                        setInputValue={setCode}
                    />
                ) : (
                    <CustomInput
                        type={"normal"}
                        placeholder={Translate("placeholder.code")}
                        inputValue={code}
                        setInputValue={setCode}
                    />
                )}
            </Row>
            <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} padding={"0 0 0 12px"}>
                <SizedBox width={"145px"} alignItem={"flex-start"} height={"auto"}>
                    <C3Text>{Translate("country")}</C3Text>
                </SizedBox>
                <CustomInput
                    type={"select"}
                    placeholder={""}
                    dropdownValues={countryValues}
                    inputValue={selectedCountry}
                    setInputValue={setSelectedCountry}
                />
            </Row>
            <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
            <Row width={"100%"} alignItem={"flex-start"} padding={"0 0 0 12px"}>
                <SizedBox
                    width={"145px"}
                    alignItem={"flex-start"}
                    height={"auto"}
                    justifyContent={"flex-start"}
                    padding={"12px 0"}
                >
                    <C3Text>{Translate("setting.faq.guideContent")}</C3Text>
                </SizedBox>
                <Row flex={"1"}>
                    <CustomSunEditor value={guideContent} setValue={setGuideContent} />
                </Row>
            </Row>
            <SizedBox height={"11px"} />
            <Row width={"100%"} justifyContent={"flex-end"} alignItem={"flex-end"}>
                <SecondaryButton
                    text={Translate("common.cancel")}
                    backgroundColor={Theme.color.white}
                    onClick={onCancelClick}
                />
                <SizedBox width={"13px"} />
                <PrimaryButton
                    icon={"checked_white"}
                    text={Translate("common.save")}
                    disabled={!subTitle || !selectedModelType || !code || selectedCountry === "select" || !guideContent}
                    onClick={() => {
                        if (!subTitle || !selectedModelType || !code || selectedCountry === "select" || !guideContent)
                            return;
                        // Spec: title/subtitle/modelType/code/language/guideType/deviceType/seq = query params, content = html body
                        const guideTypeMap = { ErrorCode: "E", PCC: "R", UserGuide: "U" };
                        const deviceTypeMap = { Washer: "L", Dryer: "D" };
                        const reqDto = {
                            title,
                            subtitle: subTitle,
                            modelType: selectedModelType,
                            code,
                            language: selectedCountry === "korea" ? "ko" : "en",
                            guideType: guideTypeMap[selectedGuideOption] || "U",
                            deviceType: deviceTypeMap[selectedDeviceType] || "L",
                            seq: 0,
                            content: guideContent,
                        };
                        if (dto?.guideId) {
                            service
                                .updateGuide({ ...reqDto, guideId: dto.guideId })
                                .then(() => {
                                    if (onSaveSuccess) onSaveSuccess();
                                })
                                .catch((error) => {
                                    console.error("Error updating guide:", error);
                                });
                        } else {
                            service
                                .saveGuide(reqDto)
                                .then(() => {
                                    if (onSaveSuccess) onSaveSuccess();
                                })
                                .catch((error) => {
                                    console.error("Error saving guide:", error);
                                });
                        }
                    }}
                />
            </Row>
        </SizedBox>
    );
}

export default FAQSaveContent;
